module.exports = __webpack_public_path__ + "img/1fecc6b.jpg";